module.exports = __webpack_public_path__ + "static/media/project-06.6daaa585.png";